import common from './common.json' with { type: 'json' };
import auth from './auth.json' with { type: 'json' };
import errors from './errors.json' with { type: 'json' };
import datatable from './datatable.json' with { type: 'json' };
import styleguide from './styleguide.json' with { type: 'json' };
import notifications from './notifications.json' with { type: 'json' };
import moderation from './moderation.json' with { type: 'json' };
import admin from './admin.json' with { type: 'json' };
import pwa from './pwa.json' with { type: 'json' };
import emails from './emails.json' with { type: 'json' };
import push from './push.json' with { type: 'json' };
/**
 * `en` is the source of truth for the catalog SHAPE: every scope/key that
 * exists here defines the `MessageId` union (see `../../types.ts`) and every
 * other locale is typed against this exact shape so a missing translation is
 * a compile-time error (§20.1/§20.7).
 */
export const enCatalog = {
    common,
    auth,
    errors,
    datatable,
    styleguide,
    notifications,
    moderation,
    admin,
    pwa,
    emails,
    push,
};
